import React, { useEffect } from 'react';

import clsx from 'clsx';
import { useTimer } from 'react-timer-hook';

import styles from './Timer.module.scss';

interface KbaTimerProps {
  onExpire: () => void;
  stopTimer?: boolean;
  expirySeconds: number;
}

const Timer = ({ stopTimer = false, onExpire, expirySeconds }: KbaTimerProps) => {
  const expiryTimestamp = new Date();

  expiryTimestamp.setSeconds(expiryTimestamp.getSeconds() + expirySeconds);

  const { seconds, minutes, pause } = useTimer({
    expiryTimestamp: expiryTimestamp,
    autoStart: true,
    onExpire: onExpire,
  });

  useEffect(() => {
    if (stopTimer) {
      pause();
    }
  }, [stopTimer]);

  return (
    <div className={styles.block}>
      <p>Remaining time: </p>
      <p className={clsx(minutes === 0 ? styles.last_dial : styles.dial)}>
        {minutes}:{seconds}
      </p>
    </div>
  );
};

export default Timer;
